import { listenable } from 'custom-listenable';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */


function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

var connectionState = function (options) {
    if (options === void 0) { options = {}; }
    var listener = listenable();
    var _a = options.endpoints, endpoints = _a === void 0 ? [] : _a, _b = options.initialState, initialState = _b === void 0 ? 'online' : _b, _c = options.retryInterval, retryInterval = _c === void 0 ? 5000 : _c;
    var endpointsCheckCounter = 0;
    var endpointsCheckTimer = null;
    var lastState = initialState;
    var areEndpointsReachable = function () { return __awaiter(void 0, void 0, void 0, function () {
        var results;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(endpoints.map(function (endpoint) { return __awaiter(void 0, void 0, void 0, function () {
                        var response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 2, , 3]);
                                    return [4 /*yield*/, fetch(endpoint, {
                                            method: 'HEAD',
                                            mode: 'no-cors',
                                        })];
                                case 1:
                                    response = _a.sent();
                                    return [2 /*return*/, response.ok || response.type === 'opaque'];
                                case 2:
                                    _a.sent();
                                    return [2 /*return*/, false];
                                case 3: return [2 /*return*/];
                            }
                        });
                    }); }))];
                case 1:
                    results = _a.sent();
                    return [2 /*return*/, results.every(function (result) { return result; })];
            }
        });
    }); };
    var startEndpointsCheck = function () {
        if (endpointsCheckTimer !== null) {
            return;
        }
        endpointsCheckLoop();
    };
    // @TODO: Rerun as soon as possible if window visibility changes to visible and focus acquired
    // @TODO: Don't check without listeners
    var endpointsCheckLoop = function () {
        endpointsCheckTimer = setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var reachable;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, areEndpointsReachable()];
                    case 1:
                        reachable = _a.sent();
                        if (reachable) {
                            if (lastState === 'offline') {
                                lastState = 'online';
                                emitState();
                            }
                        }
                        else {
                            if (lastState === 'online') {
                                lastState = 'offline';
                                emitState();
                            }
                        }
                        endpointsCheckLoop();
                        return [2 /*return*/];
                }
            });
        }); }, endpointsCheckCounter === 0 ? 0 : retryInterval);
        endpointsCheckCounter++;
    };
    var stopEndpointsCheck = function () {
        if (endpointsCheckTimer) {
            clearTimeout(endpointsCheckTimer);
            endpointsCheckTimer = null;
            endpointsCheckCounter = 0;
        }
    };
    var getState = function () { return lastState; };
    var getNewState = function () { return (navigator.onLine ? 'online' : 'offline'); };
    var handleNewState = function (newState) {
        if (newState === 'offline') {
            lastState = newState;
            stopEndpointsCheck();
            emitState();
        }
        else if (newState === 'online') {
            startEndpointsCheck();
        }
    };
    var handleStateChange = function () {
        var newState = getNewState();
        if (newState !== lastState) {
            handleNewState(newState);
        }
    };
    var emitState = function () {
        listener.emit(getState());
    };
    if ('addEventListener' in globalThis) {
        globalThis.addEventListener('offline', handleStateChange);
        globalThis.addEventListener('online', handleStateChange);
        handleNewState(getNewState());
    }
    return {
        addListener: listener.addListener,
        removeListener: listener.removeListener,
        getState: getState,
    };
};

export { connectionState };
//# sourceMappingURL=index.es.js.map
